export default "__VITE_ASSET___YvCH80B__"